import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 2c.428 0 .774.347.774.774v6.452h6.452a.774.774 0 1 1 0 1.548h-6.452v6.452a.774.774 0 1 1-1.548 0v-6.452H2.774a.774.774 0 1 1 0-1.548h6.452V2.774c0-.427.346-.774.774-.774",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }